<footer class="footer-area" role="contentinfo">
  <div class="container footer-grid">
    <section class="footer-brand" aria-labelledby="footer-brand-heading">
      <a routerLink="/" aria-label="Eplog Properties home">
        <img src="eplog-properties-original.svg" class="footer-logo" alt="Eplog Properties" width="292"
          height="82" loading="lazy">
      </a>
      <h2 id="footer-brand-heading" class="visually-hidden">Eplog Properties LLC</h2>
      <p><strong>Eplog Properties LLC</strong> connects clients with carefully selected off-plan, renovation and
        bespoke development opportunities across Dubai and the UAE.</p>
      <ul class="social" aria-label="Social media links">
        <li><a href="https://www.facebook.com/eplogoffplan" target="_blank" rel="noopener noreferrer"
            aria-label="Follow Eplog Properties on Facebook"><img src="fb.webp" alt="" width="24" height="24" loading="lazy"></a></li>
        <li><a href="https://twitter.com/eplogoffplan" target="_blank" rel="noopener noreferrer"
            aria-label="Follow Eplog Properties on X"><img src="tw.webp" alt="" width="24" height="24" loading="lazy"></a></li>
        <li><a href="https://instagram.com/eplogoffplan" target="_blank" rel="noopener noreferrer"
            aria-label="Follow Eplog Properties on Instagram"><img src="instagram.webp" alt="" width="24" height="24" loading="lazy"></a></li>
      </ul>
    </section>

    <section class="footer-column">
      <h3 (click)="toggleQuickLinks()" class="footer-heading">Explore
        <i class="ri-arrow-down-s-line d-md-none transition-icon" [class.rotate]="isQuickLinksOpen" aria-hidden="true"></i>
      </h3>
      <nav aria-label="Footer navigation" class="mobile-collapsible" [class.show]="isQuickLinksOpen">
        <ul>
          <li><a routerLink="/offplanproject">Off-Plan Properties</a></li>
          <li><a href="/renovation-development">Build, Renovate &amp; Reposition</a></li>
          <li><a routerLink="/renovation-development/villa-flipping-investment-management">Villa Investment Management</a></li>
          <li><a routerLink="/renovation-development/calculators">Investment Calculators</a></li>
          <li><a routerLink="/eplog-services">Services</a></li>
          <li><a routerLink="/eplog-services/property-handover-owner-representation">Owner Representation</a></li>
          <li><a routerLink="/blog">News &amp; Articles</a></li>
          <li><a routerLink="/about-us">About Us</a></li>
        </ul>
      </nav>
    </section>

    <section class="footer-column">
      <h3 (click)="toggleContactInfo()" class="footer-heading">Contact
        <i class="ri-arrow-down-s-line d-md-none transition-icon" [class.rotate]="isContactInfoOpen" aria-hidden="true"></i>
      </h3>
      <div class="mobile-collapsible" [class.show]="isContactInfoOpen">
        <address>
          <a href="https://api.whatsapp.com/send?l=en&phone=+447424975205&text=I%20would%20like%20to%20speak%20with%20Eplog%20Properties"
            target="_blank" rel="noopener noreferrer"><i class="ri-whatsapp-fill" aria-hidden="true"></i> +44 7424 975205</a>
          <a href="mailto:info@eplogoffplan.com"><i class="ri-mail-fill" aria-hidden="true"></i> info&#64;eplogoffplan.com</a>
        </address>
        <ul class="footer-legal">
          <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
          <li><a routerLink="/terms-and-conditions">Terms &amp; Conditions</a></li>
          <li><a routerLink="/disclaimer">Disclaimer</a></li>
        </ul>
      </div>
    </section>

    @if (isHome) {
      <section class="footer-permit" aria-label="DLD permit QR code">
        <div class="footer-permit-qr">
          <img src="homepage-dld-permit-preview.png"
            alt="Dubai Land Department permit QR code"
            width="132" height="132" loading="lazy">
        </div>
      </section>
    }
  </div>
  <div class="container footer-bottom">
    <span>© 2026 Eplog Properties LLC. All rights reserved.</span>
    <span>Dubai, United Arab Emirates</span>
  </div>
</footer>
